export const getPagination = (page: number, defaultLimit: number, maxGamesLimit?: number) => {
  if (!maxGamesLimit) {
    return {
      page,
      limit: defaultLimit,
    };
  }
  if (page < 1) {
    return;
  }

  const pageLimit = Math.ceil(maxGamesLimit / defaultLimit);

  if (page > pageLimit) {
    return;
  }

  const pagination = page === pageLimit ? maxGamesLimit - (pageLimit - 1) * defaultLimit : defaultLimit;

  if (pagination <= 0) {
    return;
  }

  return {
    page,
    limit: pagination,
  };
};
